import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMerchantAuth } from '../contexts/MerchantAuthContext';
import { cabinetPath } from '../lib/domains';
import { Loader2 } from 'lucide-react';
import { isMerchantImpersonationActive } from '../lib/merchantSession';

interface MerchantProtectedRouteProps {
    children: React.ReactNode;
}

export const MerchantProtectedRoute: React.FC<MerchantProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading } = useMerchantAuth();
    const location = useLocation();

    // Дебаг информация
    console.log('MerchantProtectedRoute:', { isAuthenticated, isLoading, location: location.pathname });

    // Показываем загрузку пока проверяем аутентификацию
    if (isLoading || (!isAuthenticated && isMerchantImpersonationActive())) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <Loader2 className="h-8 w-8 animate-spin mx-auto mb-2" />
                    <p className="text-muted-foreground">Загрузка...</p>
                </div>
            </div>
        );
    }

    // Если пользователь не авторизован, перенаправляем на страницу входа мерчанта
    if (!isAuthenticated) {
        console.log('Мерчант не авторизован, редирект на /login');
        return <Navigate to={cabinetPath('merchant', '/login')} state={{ from: location }} replace />;
    }

    // Если мерчант авторизован, показываем защищенный контент
    console.log('Мерчант авторизован, показываем контент');
    return <>{children}</>;
};
